import { render, staticRenderFns } from "./FormattedDateComponent.vue?vue&type=template&id=5c021113&scoped=true&"
import script from "./FormattedDateComponent.vue?vue&type=script&lang=js&"
export * from "./FormattedDateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c021113",
  null
  
)

export default component.exports